export default "__VITE_ASSET__CFsCpeNI__"